package kz.dentalcrm.app.core.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.choose_gender
import dentalcrm.composeapp.generated.resources.gender_female
import dentalcrm.composeapp.generated.resources.gender_male
import kz.dentalcrm.app.theme.DefaultTheme
import org.jetbrains.compose.resources.stringResource

@Composable
fun GenderSelectionDialog(
    onDismissRequest: () -> Unit,
    onGenderSelected: (String) -> Unit
) {

    Dialog(
        properties = DialogProperties(
            usePlatformDefaultWidth = false
        ),
        onDismissRequest = onDismissRequest
    ) {
        Column(
            modifier = Modifier
                .widthIn(max = 450.dp)
                .padding(horizontal = 16.dp)
                .background(
                    color = DefaultTheme.colors.surface,
                    shape = RoundedCornerShape(24.dp)
                )
        ) {
            val genderMale = stringResource(Res.string.gender_male)
            val genderFemale = stringResource(Res.string.gender_female)

            Text(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 16.dp, vertical = 16.dp),
                text = stringResource(Res.string.choose_gender),
                color = DefaultTheme.colors.onSurface,
                style = DefaultTheme.typography.bodyLargeMedium,
                textAlign = TextAlign.Center
            )

            Spacer(modifier = Modifier.height(8.dp))

            ContentButton(
                modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                shape = RoundedCornerShape(12.dp),
                onClick = {
                    onGenderSelected(genderMale)
                    onDismissRequest()
                }
            ) {
                Text(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp, vertical = 16.dp),
                    text = genderMale,
                    color = DefaultTheme.colors.primary,
                    style = DefaultTheme.typography.bodyMediumRegular,
                    textAlign = TextAlign.Center
                )
            }

            HorizontalDivider(
                modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                thickness = 0.5.dp,
                color = MaterialTheme.colorScheme.primary.copy(
                    alpha = 0.2f
                ),
            )
            ContentButton(
                modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                shape = RoundedCornerShape(12.dp),
                onClick = {
                    onGenderSelected(genderFemale)
                    onDismissRequest()
                }
            ) {
                Text(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp, vertical = 16.dp),
                    text = genderFemale,
                    color = DefaultTheme.colors.primary,
                    style = DefaultTheme.typography.bodyMediumRegular,
                    textAlign = TextAlign.Center
                )
            }
            Spacer(modifier = Modifier.height(16.dp))
        }
    }
}
